<template>
  <div class="aimlabs-discovery-disclaimer">
    <p>
      *Requires an additional account with
      <a
        :href="aimlabsUrl"
        class="aimlabs-discovery-disclaimer__link"
        target="_blank"
      >
        aimlabs.com
      </a>
      to use Discovery features.
    </p>
  </div>
</template>

<script>
export default {
  computed: {
    aimlabsUrl () {
      return process.env.AIMLABS_WEB_URL
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_variables.scss";
@import "@/assets/style/_mixins.scss";

.aimlabs-discovery-disclaimer {
  color: $text-color-primary;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.2rem;
  text-align: center;

  @include min-tablet {
    font-size: 1.2rem;
    line-height: 1.45rem;
  }
}

.aimlabs-discovery-disclaimer__link {
  &:hover, &:visited, &:active {
    text-decoration: none;
    color: inherit;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/store/subscription/TheAimlabsDiscoveryDisclaimer.vue